(function () {
    'use strict';

    angular.module('swif.openbase')
        .config(route)
        .factory('swifOpenbaseEmailsTemplateService', swifOpenbaseEmailsTemplateService)
        .controller('OpenbaseEmailsTemplateController', OpenbaseEmailsTemplateController)
        .controller('OpenbaseEditEmailTemplateController', OpenbaseEditEmailTemplateController)
        .directive('panelEmailTemplate', panelEmailTemplate);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/email_template/table_view', {
            templateUrl: 'partials/openbase/email_template_table_view.html',
            controller: 'OpenbaseEmailsTemplateController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
        $routeProvider.when('/configuration/email_template/explorer_view', {
            templateUrl: 'partials/openbase/email_template_explorer_view.html',
            controller: 'OpenbaseEmailsTemplateController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', function (route) {
                    return route.check();
                }]
            }
        });
    }

    function OpenbaseEmailsTemplateController($scope, swifModule, swifOpenbaseEmailsTemplateService) {
        'ngInject';
        $scope.modules = swifOpenbaseEmailsTemplateService.modules;
        swifOpenbaseEmailsTemplateService.createCollection().then(function (collection) {
            $scope.emailTemplates = collection;
        });
        $scope.swifModule = swifModule;
        $scope.callback = swifOpenbaseEmailsTemplateService.callback;
        $scope.preValidate = swifOpenbaseEmailsTemplateService.preValidate;
        $scope.preModal = swifOpenbaseEmailsTemplateService.preModal;
    }

    function swifOpenbaseEmailsTemplateService($q, swif, settingsService, swifOpenbaseLanguageService) {
        'ngInject';
        var service = {};
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');

            var defaultLang = settingsService.app.defaultValues.user.context_lang;
            var lang = swifOpenbaseLanguageService.getIsoCode(defaultLang);
            swif.data.addFilter(filter, 'templ_lang', 'in', [lang]);

            //we only ask for email template used by installed module
            var models = [];
            if (swif.module.modules.openresa){
                models.push('openresa.request');
            }
            if (swif.module.modules.openstc){
                models.push('openstc.ask');
                models.push('openstc.ask.contrib');
                models.push('openstc.ask.transfer');
                models.push('project.project');
                models.push('project.project.transfer');
                models.push('project.task');
            }
            if (swif.module.modules.openstc_achat_stock){
                models.push('model_purchase_order');
                models.push('mopenbase.model_openbase_log');
                models.push('model_purchase_order_ask_partners');
                models.push('model_openstc_ask_prod');
            }

            if (swif.module.modules.opengst_import_fuel){
                models.push('opengst.import_fuel.task');
            }

            swif.data.addExtraFilter(filter, 'modelFilterId', 'model', 'in', models);
            return swif.collections.createOrUpdate('emailTemplates', 'email_template', filter);
        };
        service.getCollection = function () {
            return swif.collections.getCollection('emailTemplates');
        };

        /**
         * As email template are internationalized, we MUST update all templates (fr_FR and en_US are common locales)
         * as OpenGST is only used by french people and there is no plan to generalise i10n yet, we use same text for all
         * translatable locales.
         * To update each locale we have to made atomic calls...
         */
        service.callback = function (error, data) {
            swif.data.searchRead('res_lang', {"domain":[["translatable", "=", "1"]]}).then((knownTranslatableLangs) => {
                var defers = [];

                // Set model id on creation and remove entity relationship to avoid
                // duplicate inserts
                if (data.action.id == 'add') {
                    data.model.id = data.result.result;
                    delete data.model.entity_relationship_ids;
                }

                if(data.action.id == 'add' || data.action.id == 'edit') {
                    knownTranslatableLangs.records.map((lang) => {
                        if (lang.code != swif.settings.app.defaultContext.lang) {
                            defers.push(swif.data.save('email_template', data.model.id, data.model, {lang:lang.code}));
                        }
                    });
                }

                $q.all(defers).then(function (res) {
                    service.getCollection().defaultActionCallback(error, data);
                });
            });
        };
        service.preValidate = function (data) {
            var ret = service.getCollection().preValidate(data);

            // Update the entity relationship
            if (data.model.entity_relationship) {
                // Get the relationship type (0 means creation, 1 means update)
                var relationshipType = data.model._type == 'email_template' ? 1 : 0;

                // Get the relationship ID or 0 (means creating a new relationship)
                var relationshipId = data.model.entity_relationship_ids ? data.model.entity_relationship_ids[0] : 0;

                data.model.entity_relationship_ids = [[relationshipType, relationshipId, {
                    entity_id: data.model.entity_relationship.entity_id[0],
                    model_data_id: data.model.entity_relationship.model_data_id[0]
                }]];
            }

            return ret;
        };
        service.preModal = function (data) {
            if (data.action.id == 'add') {
                // Set an empty initial value on create
                data.model.entity_relationship = {};
            } else if (data.action.id == 'edit' && data.model.entity_relationship_ids.length) {
                // Retrieve the entity relationship
                swif.data.get('email_template_entity_rel', data.model.entity_relationship_ids[0]).then(
                    function (response) {
                        data.model.entity_relationship = {
                            entity_id: response.entity_id,
                            model_data_id: response.model_data_id
                        };
                    });
            }
        };
        service.modules = swif.module.modules;
        return service;
    }

    function OpenbaseEditEmailTemplateController($scope, swif) {
        'ngInject';

        $scope.showHelp=false;
        //for the preview tab

        // Force `project.project` model to match `intervention` content type
        // This is because there's two `project.project` declaration on `default.json` and it can match the wrong one.
        console.log("model", $scope.model);
        console.log(swif.settings.getContentTypeFromModel($scope.model).id)
        if ($scope.model.model.match(/project\.project\.*/)) {
            $scope.templateTargetType = 'intervention';
        } else {
            $scope.templateTargetType = swif.settings.getContentTypeFromModel($scope.model.model).id;
        }
        console.log("scope", $scope.templateTargetType)
        $scope.preview = {};
        $scope.updatePreview = function ($value){
            if ($scope.preview.example){
                //call  render_template for each field with mako expressions ${expr}
                swif.data.callKw(
                    'email_template',
                    'render_template',
                    [$scope.model.body_html, $scope.model.model, $scope.preview.example[0]]
                ).then(function (values) {
                    $scope.preview.body_html = values;
                });
                swif.data.callKw(
                    'email_template',
                    'render_template',
                    [$scope.model.name, $scope.model.model, $scope.preview.example[0]]
                ).then(function (values) {
                    $scope.preview.name = values;
                });
                swif.data.callKw(
                    'email_template',
                    'render_template',
                    [$scope.model.subject, $scope.model.model, $scope.preview.example[0]]
                ).then(function (values) {
                    $scope.preview.subject = values;
                });
                swif.data.callKw(
                    'email_template',
                    'render_template',
                    [$scope.model.email_from, $scope.model.model, $scope.preview.example[0]]
                ).then(function (values) {
                    $scope.preview.email_from = values;
                });
                swif.data.callKw(
                    'email_template',
                    'render_template',
                    [$scope.model.email_to, $scope.model.model, $scope.preview.example[0]]
                ).then(function (values) {
                    $scope.preview.email_to = values;
                });
                swif.data.callKw(
                    'email_template',
                    'render_template',
                    [$scope.model.email_cc, $scope.model.model, $scope.preview.example[0]]
                ).then(function (values) {
                    $scope.preview.email_cc = values;
                });
            }
        };

        $scope.updateModel = function (value) {
            swif.data.get('ir_model_data', value.id).then(function (response) {
                swif.data.get('email_template', response.res_id).then(function (response) {
                    $scope.model.model_id = response.model_id;
                });
            });
        };
    };

    // will be used in the right side of the explorer view
    function panelEmailTemplate(swif) {
        'ngInject';
        var directive = swif.panel.create_directive('email_template');
        directive.templateUrl = 'partials/openbase/panel-email-template.html';
        return directive;
    };

})();
